
export default defineNuxtRouteMiddleware(async (to) => {
  const user = useUserStore()
  const userHistory = useUserHistoryStore()
  const league = useLeagueStore()
  const leagueSlug = to.params?.league
  const isLeaguePage = to.name.startsWith('leagues') && to.name !== 'leagues'

  // Ensure fetching and storing league data
  if (isLeaguePage && leagueSlug !== league.slug) {
    try {
      const response = await $fetch(`/api/v1/leagues/${leagueSlug}`, { 
        baseURL: useEnv('apiBase'),
      })
      league.addLeague(response.league)
    } catch (error) {
      // Reset league on error
      league.$reset()
    }
  }

  // Add to history 
  if (isLeaguePage && to.name !== 'leagues-league-game') {
    userHistory.addToHistory({
      id: league?.id,
      date: useDate().format('YYYY-MM-DD HH:mm:ss'),
      type: 'league',
      href: to.href,
      slug: league?.slug,
      name: league?.name,
      abbr: league?.abbr,
      logo: league?.logo,
    })
  }
})